import { render, staticRenderFns } from "./ListInspectionPage.vue?vue&type=template&id=27b0a727"
import script from "./ListInspectionPage.vue?vue&type=script&lang=js"
export * from "./ListInspectionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports